import { mapGetters, mapMutations } from 'vuex';
import { lgas } from '../states.js';
import { config } from '../config';

const gotoNextModalMixin = {
	data() {
		return {
			payload: {
				dialCode: '',
				password: '',
				otp: '',
				active: false,
				tel: '',
				bvn: '',
				email: '',
				passport: null,
				firstname: '',
				lastname: '',
				date_of_birth: '',
				address: '',
				apartment: '',
				city: '',
				terms: false,
				account_number: '',
				state: '',
				number: '',
				auth_code: null
			},
			confirm_password: ''
		};
	},
	computed: {
		...mapGetters(['getStatus', 'getUserOnlineStatus', 'getDistinctId', 'getMerchantEnvironment', 'getTestStatus', 'getUserTypedData']),
		countryCode() {
			return `+${this.payload.dialCode}`;
		},
		comparePassword() {
			return this.payload.password !== this.confirm_password;
		},
		localGovermentAreas() {
			let state = this.payload.state.replace(' ', '');
			return lgas[state];
		}
	},
	watch: {
		payload: {
			deep: true,
			handler(value) {
				this.dialCode = value.dialCode;
			}
		}
	},
	methods: {
		...mapMutations(['clearErrorMessage']),
		onSelect({ dialCode: dialCode }) {
			this.payload.dialCode = dialCode;
		},
		saveOtpCode(code) {
			this.payload.otp = code;
		},
		/*
		 * handles the states for moving to the NEXT modal
		 * NEXT: can be previous modal or subsequent modal
		 */
		gotoNextModal(isValid, data, nextModal) {
			if (!isValid) {
				this.clearErrorMessage();
				// log to mixpanel
				this.mixpanelTracker({
					step_name: `Go to ${nextModal}`,
					distinct_id: this.getDistinctId,
					payload: data
				});
				this.$emit('gotoNextModal', {
					next: nextModal,
					payload: { ...data }
				});
				this.$gtag.event('begin_checkout', {
					event_category: 'checkout',
					event_label: 'checkout_user',
					value: nextModal
				});
			}
		},

		/**
		 * handles mixpanel tracking
		 * @param {string} step_name
		 * @param {string} distinct_id
		 * @param {object} [payload]
		 * @param {string} [alias_value]
		 * @returns void
		 */
		mixpanelTracker(param) {
			const { step_name, distinct_id, payload, alias_value, partner } = param;
			if (config.is_mixpanel_enabled || (process.env.VUE_APP_NODE_ENV === 'production' && typeof this.getMerchantEnvironment?.is_live !== 'undefined' && !this.getMerchantEnvironment?.is_live)) {
				return;
			}
			const data = {
				environment: process.env.VUE_APP_NODE_ENV,
				merchant_environment: typeof this.getMerchantEnvironment?.is_live !== 'undefined'
					&& this.getMerchantEnvironment?.is_live
					? 'live'
					: 'test',
				distinct_id,
				time_date: new Date().toLocaleString(),
				collected_email: this.getUserTypedData?.email,
				collected_phone: this.getUserTypedData?.phoneNumber,
				source: 'web'
			};
			payload ? data.payload = payload : null;
			partner ? data.partner = partner : null;
			this.$mixpanel.track(step_name, data);
			if (alias_value) {
				this.$mixpanel.people.set({
					$email: alias_value
				});
				this.$mixpanel.alias(alias_value, distinct_id);
			}
		}
	}
};
export default gotoNextModalMixin;
